import { Stack, Typography } from "@mui/material";
import { Modal } from "@/components/elements/Modal";
import { FCC } from "@/types/common";
import { UseVisibleReturn } from "@/hooks/useVisible";

type TConfirmLeaveModalProps = {
  modal: UseVisibleReturn;
  onOk: () => void;
};
export const ConfirmLeaveModal: FCC<TConfirmLeaveModalProps> = ({ modal, onOk }) => {
  return (
    <Modal isOpen={modal.visible} onClose={modal.close} onOk={onOk} labelClose="いいえ" labelOk="はい" width={500}>
      <Stack mb={2}>
        <Typography>入力が完了していません。このまま戻ってもよろしいですか？</Typography>
      </Stack>
    </Modal>
  );
};
